import React, { Component } from 'react';
import { api, fileUpload } from '../services/api';
import SimpleReactValidator from 'simple-react-validator';
import { ComboBox } from './ComboBox';
import { showNotification } from './BaseNotification';
import DateTimePicker from './DateTimePicker';
import { v4 as uuid } from 'uuid';
import AttachmentsWidget from './AttachmentsWidget';
import Recaptcha from 'react-google-invisible-recaptcha';
import Courtesy from './Courtesy';
import { Offline, Online } from './common/OnlineOffline';
import moment from 'moment';
import imageCompression from 'browser-image-compression';
import Info16 from '@carbon/icons-react/lib/information--filled/24';
import Locked16 from '@carbon/icons-react/lib/locked/16';
import {
  FormLabel,
  FormGroup,
  DropdownSkeleton,
  Form,
  Button,
  TextInput,
  TextArea,
  Toggle,
  TooltipIcon,
} from 'carbon-components-react';

const executionContext = window._config?.REACT_APP_EXECUTION_CONTEXT ||
  process.env.REACT_APP_EXECUTION_CONTEXT;

const captchaKey = window._config?.REACT_APP_GOOGLE_CAPTCHA_KEY ||
  process.env.REACT_APP_GOOGLE_CAPTCHA_KEY;
const bc = "b2ZmbGluZS1icm93c2VyLWNhcHRjaGEtc3RyaW5n";
const captchaDisabled = window._config?.REACT_APP_CAPTCHA_DISABLED ||
  process.env.REACT_APP_CAPTCHA_DISABLED;

const maxAttachmentNumber = window._config?.REACT_APP_MAX_ATTACHMENT_NUMBER ||
  process.env.REACT_APP_MAX_ATTACHMENT_NUMBER;
const maxOnlineAttachmentSizeKB = window._config?.REACT_APP_MAX_ONLINE_ATTACHMENT_SIZE_KB ||
  process.env.REACT_APP_MAX_ONLINE_ATTACHMENT_SIZE_KB;
const maxOfflineAttachmentSizeKB = window._config?.REACT_APP_MAX_OFFLINE_ATTACHMENT_SIZE_KB ||
  process.env.REACT_APP_MAX_OFFLINE_ATTACHMENT_SIZE_KB;
let maxAttachmentSizeKB = navigator.onLine ? maxOnlineAttachmentSizeKB : maxOfflineAttachmentSizeKB;
console.log(`Home: navigator.onLine: ${navigator.onLine} maxAttachmentSizeKB: ${maxAttachmentSizeKB} maxOnlineAttachmentSizeKB: ${maxOnlineAttachmentSizeKB} maxOfflineAttachmentSizeKB: ${maxOfflineAttachmentSizeKB}`);

const hocModelProps = {
  idProject: null,
  idWorksite: null,
  idHocType: null,
  idInfoOriginator: null,
  idHazardType: null,
  idLifeSavingRule: null,
  occurredAt: moment(new Date()).format("YYYY-MM-DD"),
  location: '',
  description: '',
  immediateActions: '',
  fullname: '',
  stopWorkAuthority: false,
  fiveStars: false,
  attachments: []
};

export class Home extends Component {
  static displayName = Home.name;

  constructor(props) {
    console.log(`Home.constructor:`);
    super(props);
    const hoc4allTranslate = window.localStorage.getItem("hocCardTranslate");//RITM0954296
    this.state = {
      anonymous: false,
      // Dropdown option lists
      projects: [],
      worksites: [],
      hocTypes: [],
      infoOriginators: [],
      hazardTypes: [],
      lifeSavingRules: [],

      // Submit model
      hocModel: { ...hocModelProps },
      files: [],

      // Forces form re-rendering
      resetFormKey: 0,

      // Loading states
      loadingOptions: true,
      uploadingAttachments: false,
      uploadErrors: false,
      submitting: false,
      compressing: false,

      // Network connectivity status
      online: navigator.onLine,
      persistSupport: false,
      //hocCardTranslateFields:[],
      hocCardTranslateFields: JSON.parse(hoc4allTranslate), //RITM0954296     
    };

    this.validator = new SimpleReactValidator();
  }

  async componentDidMount() {
    console.log(`Home.componentDidMount:`);
    window.addEventListener('unload', this.handleUnload);
    if (!('serviceWorker' in navigator))
      showNotification.error(this.state.hocCardTranslateFields?.msgError || "Error!", this.state.hocCardTranslateFields?.msghoc4allBrowser || "This browser is not supported. Please use an updated Chrome browser.");

    if (!('SyncManager' in window))
      showNotification.warning(this.state.hocCardTranslateFields?.msgWarning || "Warning!", this.state.hocCardTranslateFields?.msghoc4allBrowserSync || "This browser doesn't support data synchronization. You may loss HOC submitted during missing network connection. Please use an updated Chrome browser.");

    // try to persist data to avoid IndexDB localforage queue to be cleared automatically
    // and lost saved HOC in offline mode, still not synchronized.
    try {
      if (navigator.storage && navigator.storage.persist) {
        await navigator.storage.persist().then((persistent) => {
          if (persistent) {
            this.setState({ persistSupport: true });
            console.log(`Home.componentDidMount: this.state.persistSupport ${this.state.persistSupport}`);
            console.log("Home.componentDidMount: Storage will not be cleared except by explicit user action");
          } else {
            console.warn("Home.componentDidMount: Storage may be cleared by the UA under storage pressure.");
          }
        });
      } else {
        console.warn("Home.componentDidMount: navigator.storage or navigator.storage.persist not available. Storage may be cleared by the UA under storage pressure.");
      }
    } catch (ex) {
      console.error("Home.componentDidMount: navigator.storage or navigator.storage.persist not available. Storage may be cleared by the UA under storage pressure.", ex);
    }
    console.log(`Home.componentDidMount: this.state.persistSupport (2) ${this.state.persistSupport}`);
    if (!this.state.persistSupport === true)
      showNotification.warning(this.state.hocCardTranslateFields?.msgWarning || "Warning!", this.state.hocCardTranslateFields?.msghoc4allPersistent || "Persistent storage in offline mode is not available or guaranted. You may loss HOCs submitted during missing network connection.");

    if (typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean') {
      this.setState({ online: navigator.onLine });
      console.log(`Home.componentDidMount: navigator.onLine: ${navigator.onLine} this.state.online ${this.state.online} maxAttachmentSizeKB: ${maxAttachmentSizeKB}`);
    } else {
      console.warn(`Home.componentDidMount: unable to get the online status`);
    }

    api.getAll('options')
      .then(res => {
        this.setState({ ...res.data });
        if (res.status === 200) {
          console.log(`Home.componentDidMount: projects: ${this.state.projects.length} worksites: ${this.state.worksites.length} hocTypes: ${this.state.hocTypes.length} infoOriginators: ${this.state.infoOriginators.length} hazardTypes: ${this.state.hazardTypes.length} lifeSavingRules: ${this.state.lifeSavingRules.length}`);
          this.setWorksiteAndProject();
        }
      })
      .catch(ex => {
        showNotification.error(this.state.hocCardTranslateFields?.msgError || "Error!", this.state.hocCardTranslateFields?.msghoc4allfectingdataError || "There was a problem fetching data.");
        console.error("Home.componentDidMount:", ex);
      })
      .finally(() => {
        this.setState({ loadingOptions: false });
      });

    //RITM0954296
    if (this.state.hocCardTranslateFields == null)
      this.getHocCardTranslate();
    //End
  }

  //RITM0954296
  getHocCardTranslate = () => {
    window.localStorage.removeItem("hocCardTranslate");
    window.localStorage.removeItem("selectedLanguage");
    window.localStorage.setItem("selectedLanguage", 'English');
    api.translate
      .get('options', { params: { language: 'English' } })
      .then((response) => {
        this.setState({ hocCardTranslateFields: response.data });
        window.localStorage.setItem("hocCardTranslate", JSON.stringify(this.state.hocCardTranslateFields));
      })
  };
  //End

  componentWillUnmount() {
    console.log(`Home.componentWillUnmount: navigator.onLine: ${navigator.onLine} state.online: ${this.state.online}`);
  }

  handleUnload = (e) => {
    console.log(`Home.handleUnload: navigator.onLine: ${navigator.onLine} state.online: ${this.state.online}`);
  }

  setWorksiteAndProject = () => {
    console.log(`Home.setWorksiteAndProject:`);
    const selectedWorksiteId = this.props.match.params.worksiteId;
    const selectedProjectId = this.props.match.params.projectId;
    const validUrl =
      this.state.worksites.some(x => x.id === selectedWorksiteId) &&
      this.state.projects.some(x => x.id === selectedProjectId);
    if (validUrl) {
      // store selected worksite and project in order to correctly restore
      // them when resetting form
      hocModelProps.idWorksite = selectedWorksiteId;
      hocModelProps.idProject = selectedProjectId;

      const hocModel = { ...this.state.hocModel };
      hocModel.idWorksite = selectedWorksiteId;
      hocModel.idProject = selectedProjectId;
      this.setState({
        hocModel
      }, () => {
        this.setState(prevState => ({
          resetFormKey: prevState.resetFormKey + 1
        }));
      });
    }
  };

  handleDropdownChange = (inputName, selectedItem) => {
    const inputValue = selectedItem ? selectedItem.id : null;
    const hocModel = { ...this.state.hocModel };
    if (inputName === "idWorksite") hocModel["idProject"] = null;
    hocModel[inputName] = inputValue;
    //RITM1070983
    if (inputName === "idHocType" && (selectedItem && selectedItem.code === "HOCTYPE001_POS"))
    {
      hocModel["stopWorkAuthority"] = false;
      hocModel["fiveStars"] = false;
      hocModel["idHazardType"] = null;
      hocModel["idLifeSavingRule"] = null;
    }
    //End
    this.setState({ hocModel });
  };

  handleToggle = (inputName, selectedItem) => {
    const inputValue = !!selectedItem;
    const hocModel = { ...this.state.hocModel };
    hocModel[inputName] = inputValue;
    this.setState({ hocModel });
  };

  anonymousToggle = (inputValue) => {
    const hocModel = { ...this.state.hocModel };
    if (inputValue) hocModel["fullname"] = null;
    this.setState({ hocModel, anonymous: inputValue });
  };

  handleTextInputChange = el => {
    const inputName = el.target.name;
    const inputValue = el.target.value;
    const hocModel = { ...this.state.hocModel };
    hocModel[inputName] = inputValue ? inputValue : '';
    this.setState({ hocModel });
  };

  handleTextAreaChange(value, inputName) {
    this.setState((prevState) => {
      const hocModel = { ...this.state.hocModel };
      hocModel[inputName] = value ? value : '';
      return { hocModel };
    });
  }

  handleDateChange = (inputName, inputValue, objName) => {
    this.setState((prevState) => ({
      [objName]: {
        ...prevState[objName],
        [inputName]: inputValue,
      },
    }));
  };

  deleteAttachment = index => {
    console.log(`Home.deleteAttachment:`);
    let files = [...this.state.files];
    files.splice(index, 1);
    this.setState({ files });
  };

  handleAddFile = async event => {
    const file = event.target.files[0];
    console.log(`Home.handleAddFile: navigator.onLine: ${navigator.onLine} file.name: ${file.name} .size: ${file.size / 1024} KB`);
    let processedFile = file;
    let fileSizeKB = file.size / 1024;
    maxAttachmentSizeKB = navigator.onLine ? maxOnlineAttachmentSizeKB : maxOfflineAttachmentSizeKB;
    let finalSizeMB = maxAttachmentSizeKB / 1024;
    if (file.type === "image/png" || file.type === "image/jpg" || file.type === "image/jpeg" || file.type === "image/gif" || file.type === "image/bmp") {
      if (fileSizeKB > maxAttachmentSizeKB) {
        try {
          const compressionOptions = {
            maxSizeMB: finalSizeMB,
            useWebWorker: true,
            maxIteration: 100
          };

          console.log(`Home.handleAddFile: originalFile size ${file.size / 1024} KB  isBlob: ${file instanceof Blob}  maxAttachmentSizeKB: ${maxAttachmentSizeKB}`);

          this.setState({ compressing: true });
          const compressedFile = await imageCompression(file, compressionOptions);

          console.log(`Home.handleAddFile: compressedFile size ${compressedFile.size / 1024} KB  isBlob: ${file instanceof Blob}  maxAttachmentSizeKB: ${maxAttachmentSizeKB}`); // smaller than maxSizeMB

          processedFile = compressedFile;
        }
        catch (ex) {
          console.error("Home.handleAddFile: ", ex);
        }
        finally {
          this.setState({ compressing: false });
        }
      }
      console.log(`Home.handleAddFile: processedFile.name: ${processedFile.name} .size: ${processedFile.size / 1024} KB`);
      this.setState(prevState => {
        return {
          files: [...prevState.files, {
            content: processedFile,
            objectURL: URL.createObjectURL(processedFile),
            name: processedFile.name,
            fileIdentifier: `hoccard_${new Date().getTime()}_${processedFile.name}`
          }]
        };
      });
    } else {
      //showNotification.warning(this.state.hocCardTranslateFields?.msgWarning|| "Warning!", `Attachment ${file.name} not accepted`);
      showNotification.warning(this.state.hocCardTranslateFields?.msgWarning || "Warning!", `${this.state.hocCardTranslateFields?.AttachmentTitle} ${file.name} ${this.state.hocCardTranslateFields?.msghoc4allNotAccepted}`);
    }
  };

  trackUploadProgress = (progressEvent, file) => {
    this.setState(prevState => {
      let files = [...prevState.files];
      const fileIndex = this.state.files.indexOf(file);
      files[fileIndex].uploadProgress = (progressEvent.loaded * 100) / progressEvent.total;
      return { files };
    });
  };

  finalizeFileUpload = () => {
    console.log(`Home.finalizeFileUpload:`);
    this.setState(prevState => {
      let files = [...prevState.files];
      files.forEach(f => f.uploadProgress = 100);
    });
  };

  resetComponent = () => {
    console.log('Home.resetComponent: ----- RESETTING ------');
    this.validator.hideMessages();
    this.setState(prevState => ({
      hocModel: { ...hocModelProps },
      files: [],
      resetFormKey: prevState.resetFormKey + 1,
      submitting: false,
      uploadingAttachments: false
    }));
  };

  buildSubmitModel = () => {
    console.log(`Home.buildSubmitModel:`);
    let hocModel = { ...this.state.hocModel };
    hocModel.id = uuid();
    hocModel.attachments = this.state.files.map(f => ({
      idAttachment: uuid(),
      IdHocCard: hocModel.id,
      fileIdentifier: f.fileIdentifier,
      name: f.name
    }));
    hocModel.captcha = this.state.online ? this.recaptcha?.getResponse() : bc;
    return hocModel;
  };

  startFileUploads = async () => {
    console.log(`Home.startFileUploads:`);
    let promises = this.state.files.map(async (f) => {
      try {
        const formData = new FormData();
        formData.append('File', f.content, f.name);
        formData.append('FileIdentifier', f.fileIdentifier);
        console.log(`Home.startFileUploads: f.name: ${f.name} f.content.name: ${f.content.name} f.fileIdentifier: ${f.fileIdentifier}`);
        const res = await fileUpload.post(formData, progressEvent => this.trackUploadProgress(progressEvent, f));
        console.log(`Home.startFileUploads: f.fileIdentifier: ${f.fileIdentifier} response.status: ${res.status}`);
        if (res.status === 201) {
          showNotification.warning(this.state.hocCardTranslateFields?.msgWarning || "Warning!", `File ${f.name} ${this.state.hocCardTranslateFields?.msghoc4allQueued}`);
          this.setState({ uploadErrors: true });
        }
      } catch (ex) {
        showNotification.error(this.state.hocCardTranslateFields?.msghoc4allErrorUpload || "Error uploading file!", ex.message);
        this.setState({ uploadErrors: true });
      }
    });
    return promises;
  };

  uploadFilesInParallel = async () => {
    console.log(`Home.uploadFilesInParallel:`);
    const fileUploadHandlers = await this.startFileUploads();
    await Promise.all(fileUploadHandlers);
  };

  uploadFilesSequentially = async () => {
    console.log(`Home.uploadFilesSequentially:`);
    for (let f of this.state.files) {
      try {
        const formData = new FormData();
        formData.append('File', f.content, f.name);
        formData.append('FileIdentifier', f.fileIdentifier);
        console.log(`Home.uploadFilesSequentially: f.name: ${f.name} f.content.name: ${f.content.name} f.fileIdentifier: ${f.fileIdentifier}`);
        const res = await fileUpload.post(formData, progressEvent => this.trackUploadProgress(progressEvent, f));
        console.log(`Home.uploadFilesSequentially: f.fileIdentifier: ${f.fileIdentifier} response.status: ${res.status}`);
        if (res.status === 201) {
          //showNotification.warning("Warning!", `File ${f.name} queued for upload due to server error or unreachable. Refresh the page to try again.`);
          showNotification.warning(this.state.hocCardTranslateFields?.msgWarning || "Warning!", `File ${f.name} ${this.state.hocCardTranslateFields?.msghoc4allQueued}`);
          this.setState({ uploadErrors: true });
        }
      } catch (ex) {
        showNotification.error(this.state.hocCardTranslateFields?.msghoc4allErrorUpload || "Error uploading file!", ex.message);
        this.setState({ uploadErrors: true });
      }
    }
  };

  submit = async () => {
    this.setState({
      uploadingAttachments: true,
      uploadErrors: false
    });
    console.log(`Home.submit: navigator.onLine: ${navigator.onLine} uploadingAttachments: ${this.state.uploadingAttachments}`);

    // If network connectivity is detected, upload files in parallel to
    // maximize throughput. Otherwise, load files sequentially - this is
    // required for service worker to queue updates correctly.
    // Notice there is little performance loss, since enqueuing files in
    // browser local storage is a very fast operation.
    if (this.state.online) {
      await this.uploadFilesInParallel();
    }
    else {
      await this.uploadFilesSequentially();
    }

    this.finalizeFileUpload();

    this.setState({
      uploadingAttachments: false,
      submitting: true
    });
    const hocModel = this.buildSubmitModel();
    api.post('options', hocModel)
      .then(res => {
        console.log("Home.submit: ", res);
        if (res.status === 201)
          showNotification.warning(this.state.hocCardTranslateFields?.msgWarning || "Warning!", this.state.hocCardTranslateFields?.msghoc4allHocQueuedError || 'HOC queued for upload due to server error or unreachable. Refresh the page to try again.');
        //showNotification.warning("Warning!", 'HOC queued for upload due to server error or unreachable. Refresh the page to try again.');

        else if (this.state.uploadErrors)
          showNotification.warning(this.state.hocCardTranslateFields?.msgWarning || "Warning!", this.state.hocCardTranslateFields?.msghoc4allSubmittedAttachmentError || "HOC data submitted successfully with attachments upload errors");
        //showNotification.warning("Warning!", "HOC data submitted successfully with attachments upload errors");
        else {
          showNotification.success(this.state.hocCardTranslateFields?.msgSuccess || "Success!", this.state.hocCardTranslateFields?.msghoc4allHocSubmitted || "HOC submitted successfully");
          if (navigator.onLine) {
            console.log("Home.submit: force synching...");
            navigator.serviceWorker.ready.then((registration) => {
              registration.active.postMessage({ type: "autoSyncQueue" });
            });
          }
        }
        this.resetComponent();
      })
      .catch(ex => {
        console.error("Home.submit: failed: ", ex);
        let message;
        switch (ex.response?.status) {
          case 403:
            message = this.state.hocCardTranslateFields?.msghoc4allCaptcha || "Captcha verification failed."
            break;
          default:
            message = this.state.hocCardTranslateFields?.msghoc4allSubmittingHocError || "There was a problem while submitting the HOC."
        }
        showNotification.error(this.state.hocCardTranslateFields?.msgError || "Error!", message);
      })
      .finally(() => {
        this.setState({ submitting: false });
      });
  };

  handleCaptchaResolved = async () => {
    const token = this.recaptcha.getResponse();
    console.log("Home.handleCaptchaResolved: ", token);
    if (token !== '') {
      await this.submit();
    }
    this.recaptcha.reset();
  };

  handleCaptchaError = err => {
    console.log('Home.captcha error: ', err);
    console.log('Home.captcha error: ', this.recaptcha.getResponse());
  };

  handleSubmit = async event => {
    console.log('Home.handleSubmit:');
    if (this.validator.allValid()) {
      event.preventDefault();
      if (executionContext === 'Center' && !captchaDisabled && this.state.online) {
        this.recaptcha.execute();
      } else {
        await this.submit();
      }
    } else {
      showNotification.warning(this.state.hocCardTranslateFields?.msgWarning || "Warning!", this.state.hocCardTranslateFields?.msghoc4allRequiredFields || 'Required fields are missing');
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  handleClearForm = () => {
    console.log('Home.handleClearForm:');
    this.resetComponent();
  };

  getProject(idWorksite) {
    if (idWorksite != null) {
      const data = (this.state.projects || []).filter((el) => el.idWorksite === idWorksite);
      return data;
    }
    return [];
  }

  handleOnlineChange = isOnline => {
    maxAttachmentSizeKB = isOnline ? maxOnlineAttachmentSizeKB : maxOfflineAttachmentSizeKB;
    console.log(`Home.handleOnlineChange: isOnline: ${isOnline} navigator.onLine: ${navigator.onLine} maxAttachmentSizeKB: ${maxAttachmentSizeKB}`);
    this.setState({ online: isOnline });

    if (isOnline) {
      console.log("Home.handleOnlineChange: force synching...");
      navigator.serviceWorker.ready.then((registration) => {
        registration.active.postMessage({ type: "autoSyncQueue" });
      });
    }
  };

  render() {
    console.log(`Home.render: navigator.onLine: ${navigator.onLine} state.online: ${this.state.online} submitting: ${this.state.submitting} compressing: ${this.state.compressing} files: ${this.state.files.length} loadingOptions: ${this.state.loadingOptions} uploadingAttachments: ${this.state.uploadingAttachments}`);

    const listProject = this.state.hocModel.idWorksite
      ? this.getProject(this.state.hocModel.idWorksite)
      : [];
    const idHocTypePOS = (this.state.hocTypes || []).find((el) => el.code === "HOCTYPE001_POS")?.id || null; //RITM1070983
    const validations = {
      hocType: this.validator.message('hocType', this.state.hocModel.idHocType, 'required'),
      occurredAt: this.validator.message('date', this.state.hocModel.occurredAt, 'required'),
      worksite: this.validator.message('worksite', this.state.hocModel.idWorksite, 'required'),
      project: this.validator.message('project', this.state.hocModel.idProject, 'required'),
      location: this.validator.message('location', this.state.hocModel.location, 'required'),
      description: this.validator.message('description', this.state.hocModel.description, 'required'),
      immediateActions: this.validator.message('immediateActions', this.state.hocModel.immediateActions, 'required'),
      fullname: this.validator.message('fullName', this.state.anonymous ? true : this.state.hocModel.fullname, 'required'),

      //RITM0544085 & RITM0530003
      idInfoOriginator: this.validator.message('H O C Raised By', this.state.hocModel.idInfoOriginator, 'required'), //RITM0954296
      idHazardType: this.validator.message('HazardType',(this.state.hocModel.idHocType === idHocTypePOS ? true : this.state.hocModel.idHazardType), 'required'), //RITM1070983
      idLifeSavingRule: this.validator.message('LifeSavingRule',(this.state.hocModel.idHocType === idHocTypePOS ? true : this.state.hocModel.idLifeSavingRule), 'required'), //RITM1070983

    };

    return (
      this.state.loadingOptions || (this.state.hocModel.idWorksite && this.state.hocModel.idProject) ? (
        <div className="home">
          <div className={`loading-overlay
          ${this.state.uploadingAttachments || this.state.submitting ? 'visible' : ''}`}
          />

          <div className="bx--row" >
            <h3 className="header-with-padding">{this.state.hocCardTranslateFields?.hoc4allAddNewHoc || "ADD NEW HOC"}</h3>
            <TooltipIcon
              tooltipText={this.state.hocCardTranslateFields?.hoc4allInfo || "Send your suggestion on positive and negative practices observed. The Hazard Observation Card system ensures a continuous improvement of the HSE management System and help to reduce risk and the number of incidents."}
            >
              <Info16
                className="infoIcon"
              />
            </TooltipIcon>
          </div>
          <Form className="bx--row" key={this.state.resetFormKey}>

            <FormGroup key="date-picker-occ" className="bx--col-md-4 bx--col-lg-4" legendText="">
              <FormLabel className="some-class-label">{this.state.hocCardTranslateFields?.dateOfOccurrenceTitle || "Date Of Occurrence*"}</FormLabel>
              <DateTimePicker
                value={this.state.hocModel.occurredAt}
                type="date"
                placeholder={"DD/MM/YYYY"}
                name="occurredAt"
                alt="hocModel"
                invalid={validations.occurredAt != null}
                onChange={this.handleDateChange}
                disabled={this.props.isDisabled}
                id="date-picker"
                disableFutureDate
              />
              {/* RITM0954296 */}
              {/* {validations.occurredAt} */}
              {validations.occurredAt ? (
                <div className="srv-validation-message">
                  {this.state.hocCardTranslateFields?.msgDateofOccurrence || validations.occurredAt}
                </div>
              ) : null}
              {/* End */}
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel className="some-class-label"> {this.state.hocCardTranslateFields?.worksitesTitle || "WorkSite*"} <Locked16 className="lockedIcon" /></FormLabel>
              {this.state.loadingOptions ? (
                <DropdownSkeleton />
              ) : (
                <ComboBox
                  id="idWorksite"
                  placeholder={this.state.hocCardTranslateFields?.hoc4allWoksiteTitlePlaceholder || "Choose a WorkSite ..."}
                  name="idWorksite"
                  alt="hocModel"
                  onChange={this.handleDropdownChange}
                  itemToString={(item) => (item ? item.name : '')}
                  initialSelectedItem={this.state.worksites.find(w => w.id === this.state.hocModel?.idWorksite)}
                  items={this.state.worksites}
                  invalid={validations.worksite != null}
                  disabled={true}
                  invalidText={this.state.hocCardTranslateFields?.msgWorksite || validations.worksite} //RITM0954296
                />
              )}
              {/* RITM0954296 */}
              {/* {validations.worksite} */}
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel className="some-class-label">{this.state.hocCardTranslateFields?.projectTitle || "Project*"}</FormLabel>
              {this.state.loadingOptions ? (
                <DropdownSkeleton />
              ) : (
                <ComboBox
                  id="idProject"
                  key={`idProject_${this.state.hocModel?.idWorksite}`}
                  placeholder={this.state.hocCardTranslateFields?.hoc4allProjectTitlePlaceholder || "Choose a Project ..."}
                  name="idProject"
                  alt="hocModel"
                  onChange={this.handleDropdownChange}
                  itemToString={(item) => (item ? item.name : '')}
                  initialSelectedItem={this.state.projects.find(p => p.id === this.state.hocModel?.idProject)}
                  items={listProject}
                  disabled={this.state.hocModel.idWorksite == null}
                  invalid={validations.project != null}
                  className="projectDropdown"
                  invalidText={this.state.hocCardTranslateFields?.msgProject || validations.project} //RITM0954296
                />
              )}
              {/* RITM0954296 */}
              {/* {validations.project} */}
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel className="some-class-label">{this.state.hocCardTranslateFields?.locationTitle || "Location*"}</FormLabel>
              <TextInput
                id="idLocation"
                name="location"
                alt="hocModel"
                value={this.state.hocModel?.location || ''}
                onChange={this.handleTextInputChange}
                placeholder={this.state.hocCardTranslateFields?.hoc4allLocationTitlePlaceholder || "Input a Location ..."}
                type="text"
                labelText=""
                className="bx--text-input some-class bx--text-input--light"
                invalid={validations.location != null}
                invalidText={this.state.hocCardTranslateFields?.msgLocation || validations.location} //RITM0954296
              />
              {/*{validations.location}*/}
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel className="some-class-label">{this.state.hocCardTranslateFields?.hoctypesTitle || "HOC Type*"}</FormLabel>
              {this.state.loadingOptions ? (
                <DropdownSkeleton />
              ) : (
                <ComboBox
                  id="idHocType"
                  placeholder={this.state.hocCardTranslateFields?.hoc4allHoctypeTitlePlaceholder || "Choose a HocType ..."}
                  name="idHocType"
                  alt="hocModel"
                  onChange={this.handleDropdownChange}
                  itemToString={(item) => (item ? item.name : '')}
                  initialSelectedItem={this.state.hocModel?.idHocType ? this.state.hocModel.idHocType : 'Choose a HocTypes'}
                  items={this.state.hocTypes}
                  invalid={validations.hocType != null}
                  invalidText={this.state.hocCardTranslateFields?.msgHoctype || validations.hocType} //RITM0954296
                />
              )}
              {/*{validations.hocType}*/}
            </FormGroup>

          <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
            {/* RITM1070983 */}
            {/* RITM0954296 */}
            <FormLabel className="some-class-label">{this.state.hocModel.idHocType === idHocTypePOS ? (this.state.hocCardTranslateFields?.hazardtypesTitle ? this.state.hocCardTranslateFields.hazardtypesTitle : "Hazard Type") : (this.state.hocCardTranslateFields?.hazardtypesTitle ? this.state.hocCardTranslateFields.hazardtypesTitle + "*" : "Hazard Type*")}</FormLabel>
            {this.state.loadingOptions ? (
              <DropdownSkeleton />
            ) : (
                <ComboBox
                  id="idHazardType"
                  key={this.state.hocModel.idHazardType}  //RITM1070983
                  placeholder={this.state.hocCardTranslateFields?.hoc4allHazardTypeTitlePlaceholder || "Choose a Hazard Type ..."}
                  name="idHazardType"
                  alt="hocModel"
                  onChange={this.handleDropdownChange}
                  itemToString={(item) => (item ? item.name : '')}
                  //initialSelectedItem={this.state.hocModel?.idHazardType ? this.state.hocModel.idHazardType : 'Choose a HazardTypes'} //RITM1070983
                  initialSelectedItem={(this.state.hazardTypes || []).find(
                    (el) =>
                      el.id === this.state.hocModel.idHazardType
                    )}
                  items={this.state.hazardTypes}
                  invalid={validations.idHazardType}
                  disabled={this.state.hocModel.idHocType === idHocTypePOS} //RITM1070983
                  invalidText={this.state.hocCardTranslateFields?.msgHazard || validations.idHazardType} //RITM0954296
                />
              )}

              {/* RITM0558269 */}
              {this.state.hocModel.idHazardType &&
                <p className='hazardTypeDescription' >{this.state.hazardTypes ? this.state.hazardTypes.find(el => el.id === this.state.hocModel.idHazardType).description : ''}</p>
              }
            </FormGroup>


            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel className="some-class-label">{this.state.hocCardTranslateFields?.descriptionTitle || "Description of Observation*"}</FormLabel>
              <TextArea
                maxLength={5000}
                id="idDescription"
                name="description"
                alt="hocModel"
                placeholder={this.state.hocCardTranslateFields?.descriptionTitlePlaceholder || "What did you observe ..."}
                value={this.state.hocModel?.description != null ? this.state.hocModel?.description : ''}
                onChange={(e) => this.handleTextAreaChange(e.target.value, "description")}
                invalid={validations.description != null}
                invalidText={this.state.hocCardTranslateFields?.msgDescription || validations.description} //RITM0954296
                //invalidText={validations.description}
                hideLabel
                labelText=""
                light
                rows={4}
                cols={250}
              />
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel className="some-class-label">{this.state.hocCardTranslateFields?.immediateActionsTitle || "Immediate Action*"}</FormLabel>
              <TextArea
                maxLength={5000}
                id="idImmediateActions"
                name="immediateActions"
                alt="hocModel"
                placeholder={this.state.hocCardTranslateFields?.immediateActionsTitlePlaceholder || "What immediate actions did you take? (To give positive feedback/To stop the unsafe act/condition) ..."}
                value={this.state.hocModel?.immediateActions != null ? this.state.hocModel?.immediateActions : ''}
                onChange={(e) => this.handleTextAreaChange(e.target.value, "immediateActions")}
                invalid={validations.immediateActions != null}
                invalidText={this.state.hocCardTranslateFields?.msgImmediateActions || validations.immediateActions} //RITM0954296
                //invalidText={validations.immediateActions}
                hideLabel
                labelText=""
                light
                rows={4}
                cols={250}
              />
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel className="some-class-label" >{this.state.hocCardTranslateFields?.additionalInfoTitle || "Suggestion for Improvement/Recommendation"}</FormLabel>
              <TextArea
                maxLength={5000}
                id="idAdditionalInfo"
                name="additionalInfo"
                alt="hocModel"
                placeholder={this.state.hocCardTranslateFields?.additionalInfoTitlePlaceholder || "What immediate actions did you take? (To give positive feedback/To stop the unsafe act/condition) ..."}
                value={this.state.hocModel?.additionalInfo != null ? this.state.hocModel?.additionalInfo : ''}
                onChange={(e) => this.handleTextAreaChange(e.target.value, "additionalInfo")}
                hideLabel
                labelText=""
                light
                rows={4}
                cols={250}
              />
            </FormGroup>

          <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
            {/* RITM1070983 */}
            {/* RITM0954296 */}
            <FormLabel className="some-class-label">{this.state.hocModel.idHocType === idHocTypePOS ? (this.state.hocCardTranslateFields?.lifesavingrulesTitle ? this.state.hocCardTranslateFields.lifesavingrulesTitle : "Life Saving Rule Violation"): (this.state.hocCardTranslateFields?.lifesavingrulesTitle ? this.state.hocCardTranslateFields.lifesavingrulesTitle + "*" : "Life Saving Rule Violation*")}</FormLabel>
            {this.state.loadingOptions ? (
              <DropdownSkeleton />
            ) : (
                <ComboBox
                  id="idLifeSavingRule"
                  key={this.state.hocModel.idLifeSavingRule}  //RITM1070983
                  placeholder={this.state.hocCardTranslateFields?.hoc4allLifeSaveTitlePlaceholder || "Choose a Life Saving Rule Violation..."}
                  name="idLifeSavingRule"
                  alt="hocModel"
                  onChange={this.handleDropdownChange}
                  itemToString={(item) => (item ? item.name : '')}
                  //initialSelectedItem={this.state.hocModel?.idLifeSavingRule ? this.state.hocModel.idLifeSavingRule : 'Choose a LifeSavingRules'} //RITM1070983
                  initialSelectedItem={(this.state.lifeSavingRules || []).find(
                    (el) =>
                      el.id === this.state.hocModel.idLifeSavingRule
                    )}
                  items={this.state.lifeSavingRules}
                  invalid={validations.idLifeSavingRule}
                  className="open-up-combo-box"
                  disabled={this.state.hocModel.idHocType === idHocTypePOS} //RITM1070983
                  invalidText={this.state.hocCardTranslateFields?.msgLifeSavingRulesViolation || validations.idLifeSavingRule} //RITM0954296
                  />
                )}
          </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              {/* RITM0954296 */}
              <FormLabel className="some-class-label">{this.state.hocCardTranslateFields?.hoc4allInfoOriginatorTitle || "HOC Raised By*"}</FormLabel>
              {this.state.loadingOptions ? (
                <DropdownSkeleton />
              ) : (
                <ComboBox
                  id="idInfoOriginator"
                  className="open-up-combo-box"
                  placeholder={this.state.hocCardTranslateFields?.hoc4allInfoOriginatorTitlePlaceholder || "Choose a HOC Raised By ..."} //RITM0954296
                  name="idInfoOriginator"
                  alt="hocModel"
                  onChange={this.handleDropdownChange}
                  itemToString={(item) => (item ? item.name : '')}
                  initialSelectedItem={this.state.hocModel?.idInfoOriginator ? this.state.hocModel.idInfoOriginator : 'Choose a HOC Raised By'} //RITM0954296
                  items={this.state.infoOriginators}
                  invalid={validations.idInfoOriginator != null}
                  invalidText={this.state.hocCardTranslateFields?.msgHocraised || validations.idInfoOriginator} //RITM0954296
                />
              )}
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-2 bx--col-lg-2 bx--col-sm-2">
              <FormLabel className="some-class-label">{this.state.hocCardTranslateFields?.hoc4allFullname || "Full name or email*"}</FormLabel>
              <TextInput
                id="idFullName"
                name="fullname"
                alt="hocModel"
                value={this.state.hocModel?.fullname != null ? this.state.hocModel?.fullname : ''}
                onChange={this.handleTextInputChange}
                placeholder={this.state.hocCardTranslateFields?.userReportedByTitlePlaceholder || "Input User Reported By ..."}
                type="text"
                labelText=""
                className="bx--text-input some-class bx--text-input--light"
                invalid={validations.fullname != null}
                invalidText={this.state.hocCardTranslateFields?.msghoc4allFullname || validations.fullname} //RITM0954296
                disabled={this.state.anonymous}
              />
              {/*{validations.fullname}*/}
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-2 bx--col-lg-2 bx--col-sm-2">
              <FormLabel className="some-class-label">{this.state.hocCardTranslateFields?.hoc4allAnonymous || "Anonymous"}</FormLabel>
              <Toggle
                id="anonymous"
                labelText=""
                onToggle={(value) => this.anonymousToggle(value)}
                labelA="No"
                labelB="Yes"
                toggled={this.state.anonymous}
              />
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-2 bx--col-lg-2 bx--col-sm-2">
              <FormLabel className="some-class-label">{this.state.hocCardTranslateFields?.stopWorkAuthorityTitle || "Stop Work Authority"}</FormLabel>
              <Toggle
                id="stopWorkAuthority"
                alt="hocModel"
                labelText=""
                onToggle={(value, id) => this.handleToggle(id, value, 'hocModel')}
                labelA="No"
                labelB="Yes"
                toggled={this.state.hocModel.stopWorkAuthority || false}
                disabled={this.state.hocModel.idHocType === idHocTypePOS} //RITM1070983
              />
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-2 bx--col-lg-2 bx--col-sm-2">
              <FormLabel className="some-class-label">{this.state.hocCardTranslateFields?.fiveStarsTitle || "Five Stars"}</FormLabel>
              <Toggle
                id="fiveStars"
                alt="hocModel"
                labelText=""
                onToggle={(value, id) => this.handleToggle(id, value, 'hocModel')}
                labelA="No"
                labelB="Yes"
                toggled={this.state.hocModel.fiveStars || false}
                disabled={this.state.hocModel.idHocType === idHocTypePOS} //RITM1070983
              />
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel className="some-class-label">{this.state.hocCardTranslateFields?.attachmentsTitle || "Attachments"}</FormLabel>
              <AttachmentsWidget
                files={this.state.files}
                onDelete={this.deleteAttachment}
                onFileAdded={this.handleAddFile}
                maxFiles={maxAttachmentNumber}
                maxSize={maxAttachmentSizeKB}
                loadingMessage="Compressing file..."
                loading={this.state.compressing}
                AttachmentmsgMaxAttachments={this.state.hocCardTranslateFields?.msghoc4allMaxAttachments}
                AttachmentmsgMax={this.state.hocCardTranslateFields?.msghoc4allMax}
                Attachmentmsgallowed={this.state.hocCardTranslateFields?.msghoc4allallowed}
                msghoc4allFilelarger={this.state.hocCardTranslateFields?.msghoc4allFilelarger}
                msghoc4allCompressed={this.state.hocCardTranslateFields?.msghoc4allKB}
                hoc4allAddPicture={this.state.hocCardTranslateFields?.hoc4allAddPicture}
              />
            </FormGroup>

          </Form>

          <div className="bx--row">
            <div className="message-box">
              {this.state.uploadingAttachments ? `Uploading attachments...` : null}
              {this.state.submitting ? `Submitting data...` : null}
            </div>
          </div>

          <div className="bx--modal-footer">
            <Button
              className="button--max-width"
              kind="secondary"
              onClick={this.handleClearForm}>
              {this.state.hocCardTranslateFields?.ghrsClearTitle || "Clear"}
            </Button>
            <Button
              disabled={this.state.compressing}
              className="button--max-width"
              kind="primary"
              onClick={this.handleSubmit}>
              <Online>
                <span>{this.state.hocCardTranslateFields?.hoc4allsubmit || "Submit"}</span>
              </Online>
              <Offline>
                <span>{this.state.hocCardTranslateFields?.hoc4allSaveSubmit || "Save and submit later"}</span>
              </Offline>
            </Button>
          </div>
          <div className="bx--modal-footer">
            <Online
              onChange={this.handleOnlineChange}
            >
              {(executionContext === 'Center' && !captchaDisabled) ?
                <Recaptcha
                  ref={ref => this.recaptcha = ref}
                  sitekey={captchaKey}
                  onResolved={this.handleCaptchaResolved}
                  onError={this.handleCaptchaError}
                />
                :
                null
              }
            </Online>

          </div>
        </div>
      ) :
        <Courtesy />
    );
  }
}
